import { API_BASE_URL } from "../../Apicongfig";

// Common fetch function with proper payload handling
const fetchData = async (endpoint, method = 'GET', payload) => {
    try {
        const options = {
            method,
            headers: {
                'Authorization': `Bearer ${localStorage.getItem('token')}`,
                // Don't set Content-Type header when using FormData - browser will set it automatically
                ...(!(payload instanceof FormData) && { 
                    'Content-Type': 'application/json' 
                }),
            },
        };

        // Handle payload (body) for different methods
        if (payload) {
            options.body = payload instanceof FormData 
                ? payload 
                : JSON.stringify(payload);
        }

        const response = await fetch(`${API_BASE_URL}${endpoint}`, options);

        // Handle empty responses (like for 204 No Content)
        if (response.status === 204) {
            return null;
        }

        const data = await response.json();

        if (!response.ok) {
            throw {
                status: response.status,
                message: data?.message || 'Request failed',
                data: data
            };
        }

        return data;
    } catch (error) {
        console.error(`Error in ${method} request to ${endpoint}:`, error);
        
        // Enhance the error object before throwing
        const enhancedError = {
            message: error.message || 'Network request failed',
            status: error.status,
            data: error.data,
            endpoint,
            method
        };
        
        throw enhancedError;
    }
};

// Destination APIs
export const getAllDestinations = () => fetchData('/get-all-destinations');
export const getDestinationMeetings = (destinationId) => 
    fetchData(`/get-destination-all-meetings/${destinationId}`);

// Meeting APIs
export const getMeetingMoments = (meetingId) => 
    fetchData(`/get-meeting-moments/${meetingId}`);
export const getMeetingParticipants = (meetingId) => 
    fetchData(`/get-meeting/${meetingId}`);
export const getMeetingMessages = (meetingId, selectedMomentId) => 
    fetchData(`/meeting-messages?meeting_id=${selectedMomentId}`);

// Message APIs
export const createMessage = (messageData) => 
    fetchData('/meeting-messages', 'post', messageData);
export const updateMessage = (messageId, messageData) => 
    fetchData(`/meeting-messages/${messageId}`, messageData,'put');
export const deleteMessage = (messageId) => 
    fetchData(`/meeting-messages/${messageId}`, 'delete');